import React, { useState } from "react";
import { Pencil } from "lucide-react";
import { useLoad } from "../../lib/sales";
import { CommSettings, PhoneSetup } from "./PhoneCenter";
import { TelnyxSmsCard } from "./TelnyxSmsCard";

// Admin-only: everything phone-related in one place, including each rep's voicemail and email setup.
export function DialerSettings() {
  const [dir] = useLoad("/phone/directory");
  const [edit, setEdit] = useState("");
  return (
    <div className="p-3 md:p-5 grid lg:grid-cols-[minmax(0,1fr)_400px] gap-4 items-start" data-testid="dialer-settings">
      <PhoneSetup dir={dir} />
      <div className="space-y-4 lg:sticky lg:top-[120px] lg:max-h-[calc(100vh-140px)] lg:overflow-y-auto">
        <div className="bg-white border border-[var(--line)] rounded-3xl p-4" data-testid="dialer-settings-lines">
          <p className="font-serif text-xl mb-1">Reps: extensions, voicemail &amp; email</p>
          <p className="text-xs text-[#5c544b] mb-2">Incoming calls ring every rep who is online with the Call Center open. Tap a rep to set their voicemail greeting and email signature.</p>
          <div className="divide-y divide-[var(--line)]">{(dir || []).map((r) => <div key={r.user_id} data-testid={`ds-line-${r.ext}`}>
            <button onClick={() => setEdit(edit === r.user_id ? "" : r.user_id)} className="w-full py-2 flex items-center gap-2 text-sm text-left hover:bg-black/[0.02] transition-colors" data-testid={`ds-edit-${r.ext}`}>
              <span className={`w-2 h-2 rounded-full ${r.status === "online" ? "bg-emerald-500" : r.status === "busy" ? "bg-amber-500" : "bg-black/20"}`} /><span className="flex-1">{r.name}</span><b className="font-mono">{r.ext}</b>
              <span className={`text-xs ${r.browser_line ? "text-emerald-700" : "text-amber-700"}`}>{r.browser_line ? "line ready" : "no line yet"}</span><Pencil className="w-3.5 h-3.5 text-black/40" /></button>
            {edit === r.user_id && <div className="pb-3"><CommSettings uid={r.user_id} /></div>}
          </div>)}</div>
        </div>
        <TelnyxSmsCard />
      </div>
    </div>
  );
}
